/**
 * Accessibility land use types supported by the backend.
 * Layer filenames follow: accessibility_{id}.json | accessibility_{id}.png
 */
export interface AccessibilityLandUseType {
  id: string;
  label: string;
}

export const ACCESSIBILITY_LAND_USE_TYPES: AccessibilityLandUseType[] = [
  { id: "residential", label: "Residential" },
  { id: "education_research", label: "Education & Research" },
  { id: "business_services", label: "Business & Services" },
  { id: "recreation_sport", label: "Recreation & Sport" },
  { id: "culture_social", label: "Culture & Social" },
  {
    id: "vibrancy_retail_gastro_service_commerce",
    label: "Vibrancy, Retail & Commerce",
  },
  {
    id: "public_space_green_corridors_parks",
    label: "Public Space, Green Corridors & Parks",
  },
];
